
export const formLayout = 'vertical';

export const formSize = 'large';

// export const formItemLayout = {
//   labelCol: { span: 6 },
//   wrapperCol: { span: 14 }
// };
